var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMybook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5101 10.6998C14.4379 10.6998 15.1901 9.94768 15.1901 9.01984C15.1901 8.09201 14.4379 7.33984 13.5101 7.33984C12.5822 7.33984 11.8301 8.09201 11.8301 9.01984C11.8301 9.94768 12.5822 10.6998 13.5101 10.6998Z",
    fill: "#ECF4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78906 17.3102L9.94906 13.7702L13.6491 12.9902L17.5191 13.7402L17.1391 17.3102H9.78906Z",
    fill: "#ECF4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5191 17.3099V14.3599C17.5191 13.6899 16.9791 13.1499 16.3091 13.1499H10.9991C10.3291 13.1499 9.78906 13.6899 9.78906 14.3599V17.3099",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.649 10.9401C14.7204 10.9401 15.589 10.0715 15.589 9.00006C15.589 7.92863 14.7204 7.06006 13.649 7.06006C12.5776 7.06006 11.709 7.92863 11.709 9.00006C11.709 10.0715 12.5776 10.9401 13.649 10.9401Z",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 7.89014V19.9401",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 22.2499V4.93994C5.19922 4.10994 5.86922 3.43994 6.69922 3.43994H22.0992V6.55994",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7992 24.5599H7.50922C6.22922 24.5599 5.19922 23.5299 5.19922 22.2499C5.19922 20.9699 6.22922 19.9399 7.50922 19.9399H22.7192",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 22.25H22.8002",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMybook);
export default __webpack_public_path__ + "static/media/Mybook.5066689785dbb90313a596a0fdfc91cb.svg";
export { ForwardRef as ReactComponent };